import { api } from '@/lib/api';
import type {
  AddAskInput,
  CreateCustomerRequestInput,
  CustomerRequestDetail,
  CustomerRequestListResponse,
  CustomerRequestMatch,
  CustomerRequestStatus,
  StatusChangeResponse,
  UpdateCustomerRequestInput,
} from './types';

const BASE = '/v4/customer-requests';

export const listCustomerRequests = (status?: CustomerRequestStatus | 'all') =>
  api.get<CustomerRequestListResponse>(BASE, { status: status === 'all' ? undefined : status });

export const searchCustomerRequests = (q: string) =>
  api.get<{ matches: CustomerRequestMatch[] }>(`${BASE}/search`, { q });

export const getCustomerRequest = (id: string) =>
  api.get<CustomerRequestDetail>(`${BASE}/${id}`);

export const createCustomerRequest = (data: CreateCustomerRequestInput) =>
  api.post<CustomerRequestDetail>(BASE, data);

export const updateCustomerRequest = (id: string, data: UpdateCustomerRequestInput) =>
  api.patch<CustomerRequestDetail>(`${BASE}/${id}`, data);

export const setCustomerRequestStatus = (id: string, status: CustomerRequestStatus, note?: string) =>
  api.patch<StatusChangeResponse>(`${BASE}/${id}/status`, { status, note });

export const addAsk = (id: string, data: AddAskInput) =>
  api.post<CustomerRequestDetail>(`${BASE}/${id}/asks`, data);

export const removeAsk = (id: string, askId: string) =>
  api.delete<CustomerRequestDetail>(`${BASE}/${id}/asks/${askId}`);

export const deleteCustomerRequest = (id: string) =>
  api.delete(`${BASE}/${id}`);
